// Il percorso lungo riduce i tentativi automatici; l'autorizzazione reale
// resta sempre nel backend e in AdminRoute.
export const ADMIN_LOGIN_PATH = "/aurea-command-7f3c91d2-9b7e5c4a";
export const ADMIN_PATH = "/gz60k37x-niiwy0kb-ymps2jw4-tjus19xm";
